module.exports = __webpack_public_path__ + "static/media/12.ff2fad7d.mp3";